import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  routes: [
    { path: '/', name: 'homepage', component: () => import('@/pages/homepage/index') },
    { path: '/signup', name: 'signup', component: () => import('@/pages/signup/index') },
    { path: '*', redirect: '/' }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.path === '/' && to.query.section) return
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/router.js